import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IBranding } from '../interfaces/branding';
import { tap, mapTo } from 'rxjs/operators';
import { IConfiguration } from '../interfaces/configuration';
import { IExternalLinks } from '../interfaces/external-links';
import { IContactInformation } from '../interfaces/contact-information';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private rootUrl: string = "/api/configuration";
  private config: IConfiguration;

  constructor(private httpClient: HttpClient) { }

  public load(): Observable<void> {
    return this.httpClient.get<IConfiguration>('/assets/config.json')
      .pipe(
        tap((config: IConfiguration) =>
          this.config = config
        ),
        mapTo(undefined)
      );
  }

  public getConfiguration(): any {
    return this.config;
  }

  public getSecAdminLink(): Observable<string> {
    const url = this.rootUrl + "/sec-admin-link";
    return this.httpClient.get(url, { responseType: 'text' });
  }

  public getBranding(): Observable<IBranding> {
    var url = this.rootUrl + "/branding";
    return this.httpClient.get<IBranding>(url);
  }

  public getExternalLinks(): Observable<IExternalLinks> {
    var url = this.rootUrl + "/external-links";
    return this.httpClient.get<IExternalLinks>(url);
  }

  public getContactInformation(): Observable<IContactInformation> {
    var url = this.rootUrl + "/contact-information";
    return this.httpClient.get<IContactInformation>(url);
  }
}
